import { alertsActions, showOverlayActions } from '.';
import getErrorMessage from 'utils/getErrorMessage';
import { unlockFileConstants } from 'store/constants';
import { unlockFileService } from 'store/services/unlock-file.service';
import { ticketActions } from 'store/actions/ticket.action';

const unlockFile = (
  ticketId: string,
  partId: string,
  password: string,
) => {
  const request = () => {
    return {
      type: unlockFileConstants.UNLOCK_REQUEST,
      payload: {
        partId,
      },
    };
  };

  const failure = (error: string) => {
    return {
      type: unlockFileConstants.UNLOCK_ERROR,
      payload: { partId, error },
    };
  };
  const success = (unlockSuccess: boolean) => {
    return {
      type: unlockFileConstants.UNLOCK_SUCCESS,
      payload: { partId, unlockSuccess },
    };
  };
  return (dispatch, getState) => {
    dispatch(request());
    dispatch(
      ticketActions.updateTicketFileStatus(partId, 'REQUESTING'),
    );
    unlockFileService
      .postUnlockFile(ticketId, partId, password)
      .then((data: any) => {
        dispatch(success(!data.locked));
        dispatch(ticketActions.updateTicketFileStatus(partId, null));
        if (!data.locked) {
          dispatch(ticketActions.updateTicketReplaceFiles(data));
          dispatch(showOverlayActions.close('InputPassword'));
        } else if (!getState().showOverlay['InputPassword']) {
          dispatch(
            showOverlayActions.show('InputPassword', {
              ticketId,
              file: data,
            }),
          );
        }
      })
      .catch((error) => {
        const errorMessage = getErrorMessage(error);
        dispatch(failure(errorMessage as string));
        dispatch(alertsActions.error(errorMessage));
      });
  };
};

const clearUnlockFileStatusMap = () => {
  return {
    type: unlockFileConstants.CLEAR,
  };
};
export const unlockActions = {
  unlockFile,
  clearUnlockFileStatusMap,
};
